import { Container, Row, Col, Card, Button } from "react-bootstrap"
import { Link } from "react-router-dom"

const Solutions = () => {
  const solutionsData = [
    {
      id: "residential",
      title: "Residential Cleaning",
      description: "Keep your home spotless with our residential cleaning services.",
      imageUrl:
        "https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    },
    {
      id: "commercial",
      title: "Commercial Cleaning",
      description: "Professional cleaning solutions for businesses and offices.",
      imageUrl:
        "https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    },
    {
      id: "industrial",
      title: "Industrial Cleaning",
      description: "Specialized cleaning for industrial facilities and equipment.",
      imageUrl:
        "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    },
    {
      id: "specialized",
      title: "Specialized Cleaning",
      description: "Unique cleaning solutions for specific requirements.",
      imageUrl:
        "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    },
    {
      id: "maintenance",
      title: "Maintenance Services",
      description: "Regular upkeep and preventative maintenance solutions.",
      imageUrl:
        "https://images.unsplash.com/photo-1563453392212-326f5e854473?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    },
    {
      id: "sanitization",
      title: "Sanitization Services",
      description: "Thorough disinfection for healthy environments.",
      imageUrl:
        "https://images.unsplash.com/photo-1556911220-e15b29be8c8f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    },
  ]

  return (
    <Container className="py-5">
      <h1 className="text-center mb-4">Our Solutions</h1>
      <Row xs={1} md={2} lg={3} className="g-4">
        {solutionsData.map((solution) => (
          <Col key={solution.id}>
            <Card className="h-100">
              <Card.Img variant="top" src={solution.imageUrl} style={{ height: "200px", objectFit: "cover" }} />
              <Card.Body>
                <Card.Title>{solution.title}</Card.Title>
                <Card.Text>{solution.description}</Card.Text>
                <Button as={Link} to={`/solutions/${solution.id}`} variant="primary">
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  )
}

export default Solutions

